import { render, staticRenderFns } from "./VirtualForm.vue?vue&type=template&id=c55f35a8&"
import script from "./VirtualForm.vue?vue&type=script&lang=js&"
export * from "./VirtualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports